export const yearRange = (year: number): [Date, Date] => [
    new Date(year, 0, 1),
    new Date(year, 11, 31),
];

export const quarterRange = ({
    year,
    quarter,
}: {
    year: number;
    quarter: number;
}): [Date, Date] => {
    const startMonth = (quarter - 1) * 3;
    return [new Date(year, startMonth, 1), new Date(year, startMonth + 3, 0)];
};

export const monthRange = ({ year, month }: { year: number; month: number }): [Date, Date] => [
    new Date(year, month, 1),
    new Date(year, month + 1, 0),
];
